<template>
  <el-dialog
    class="attendance-details-dialog"
    :title="loading ? 'loading...' : details.date_format"
    :visible.sync="dialogVisible"
  >
    <div v-load="loading">
      <template v-if="!loading">
        <div style="margin-left: 10px">
          <div class="user">
            <div class="avatar">
              <el-avatar :src="details.avatar_url" :size="60">
                <img :src="getAvatar(0)" />
              </el-avatar>
            </div>
            <div class="info">
              <div class="username">{{ details.staff_name }}</div>
              <div class="attendance">{{ details.attendance_group_info }}</div>
            </div>
          </div>
          <div class="record record-leave">
            <div class="record-label">{{ $t('i18n.gdiYuGS8mbNq') }}</div>
            <div class="record-list">
              <div class="record-item" v-for="(item, index) in details.leaves" :key="index">{{ item }}</div>
            </div>
          </div>
          <div class="record record-overtime">
            <div class="record-label">{{ $t('i18n.0zMtil1FC4cc') }}</div>
            <div class="record-list">
              <div class="record-item" v-for="(item, index) in details.ots" :key="index">{{ item }}</div>
            </div>
            <div v-if="$p('menu.statistics.edit')" class="create-record-btn" @click="openCreateOvertimeDialog">
              {{ $t('i18n.XxhDpKVqozr0') }}
            </div>
          </div>
        </div>
      </template>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column :label="$t('546')" prop="shift" width="150" align="center"></el-table-column>
        <el-table-column :label="$t('i18n.udk6mXAaRRHb')" prop="type" width="200" align="center"></el-table-column>
        <el-table-column :label="$t('1411')" min-width="200" align="center">
          <template slot-scope="scope">
            <template v-if="$p('menu.statistics.edit')">
              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('i18n.6150067a018246d8b9d87b42c1e647e8')"
                placement="top"
              >
                <el-button type="text" @click="openUpdatePunchTimeDialog(scope, scope.$index)">
                  <span>{{ scope.row.click_at ? scope.row.click_at : scope.row.click_at_msg }}</span>
                </el-button>
              </el-tooltip>
            </template>
            <template v-else>
              <span>{{ scope.row.click_at }}</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column :label="$t('1412')" prop="click_result" width="200" align="center"></el-table-column>
        <el-table-column :label="$t('1414')" prop="remark" min-width="300" align="center"></el-table-column>
        <el-table-column :label="$t('2333')" prop="address" min-width="350" align="center"></el-table-column>
        <el-table-column
          :label="$t('i18n.nBgXcZnL0hQN')"
          prop="field_remark"
          width="200"
          align="center"
        ></el-table-column>
        <el-table-column :label="$t('1415')" prop="click_img_url" width="200" align="center">
          <template slot-scope="scope">
            <template v-if="!scope.row.click_img_url">
              <span>{{ scope.row.click_img_msg }}</span>
            </template>
            <template v-else>
              <el-avatar :src="scope.row.click_img_url" :size="45" shape="square"></el-avatar>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('66') }}</el-button>
      <el-button type="primary" :loading="loading" @click="handleConfirm">{{ $t('131') }}</el-button>
    </span>
    <CreateOvertimeDialog ref="CreateOvertimeDialog" @update="fetchData(params)" />
    <el-dialog
      class="updatePunchTimeDialog"
      :title="$t('i18n.1c38275a29bb48e1a436a212035aacc2')"
      :visible.sync="updatePunchTimeDialogVisible"
      append-to-body
    >
      <el-date-picker
        class="ui-date-picker"
        type="datetime"
        format="yyyy-MM-dd HH:mm"
        value-format="yyyy-MM-dd HH:mm"
        :picker-options="pickerOptions"
        v-model="currentRow.click_at_model"
        :placeholder="currentRow.click_at ? '' : $t('i18n.5fc99bfbddb24119998c2f8dd7d3a7c3')"
        style="min-width: 250px; width: 250px"
      ></el-date-picker>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updatePunchTimeDialogVisible = false">{{ $t('66') }}</el-button>
        <el-button
          type="primary"
          :disabled="!currentRow.click_at_model"
          :loading="updatePunchTimeLoading"
          @click="handleUpdatePunchTime"
          >{{ $t('131') }}</el-button
        >
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import CreateOvertimeDialog from './CreateOvertimeDialog.vue'
import { getAvatar } from '@/util/util'
import { createRange } from './rang'

export default {
  components: {
    CreateOvertimeDialog
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      params: {},
      details: {},
      tableData: [],
      updatePunchTimeLoading: false,
      updatePunchTimeDialogVisible: false,
      currentRow: {},
      pickerOptions: {}
    }
  },
  methods: {
    getAvatar,
    fetchData(params) {
      this.loading = true
      this.$http({
        url: '/web/statistics/attendanceDetail',
        method: 'GET',
        params
      })
        .then(res => {
          this.details = res.data
          const { attendance_list } = this.details
          const { shift, record } = attendance_list
          if (Array.isArray(record)) {
            this.tableData = record.map(item => ({
              shift,
              click_at_model: item.click_at || '',
              ...item
            }))
          }
        })
        .catch(() => {
          this.dialogVisible = false
        })
        .finally(() => {
          this.loading = false
        })
    },
    init(params) {
      this.dialogVisible = true
      this.params = params
      this.fetchData(params)
    },
    openCreateOvertimeDialog() {
      this.$refs.CreateOvertimeDialog.init(this.params)
    },
    openUpdatePunchTimeDialog(scope) {
      if (this.$p('menu.statistics.edit')) {
        this.currentRow = scope.row
        this.currentRow.click_at_model = scope.row.click_at || ''
        this.pickerOptions = createRange(this.params.attendance_date)
        this.updatePunchTimeDialogVisible = true
      }
    },
    handleUpdatePunchTime() {
      const { staff_id, attendance_date } = this.params
      const { attendance_category, click_at_model } = this.currentRow
      this.updatePunchTimeLoading = true
      this.$http({
        url: '/web/statistics/modifyClickAt',
        data: {
          staff_id,
          attendance_date,
          attendance_category,
          click_at: click_at_model
        }
      })
        .then(() => {
          this.currentRow.click_at = click_at_model
          this.updatePunchTimeDialogVisible = false
          this.fetchData(this.params)
        })
        .finally(() => {
          this.updatePunchTimeLoading = false
        })
    },
    handleConfirm() {
      this.dialogVisible = false
      this.$emit('confirm')
    }
  }
}
</script>

<style>
.attendance-details-dialog .el-avatar {
  background: transparent;
}

.attendance-details-dialog .el-avatar > img {
  width: 100%;
}
</style>

<style lang="less" scoped>
.attendance-details-dialog /deep/ .el-dialog {
  width: 1000px;
  max-width: 1000px;
}

.user {
  display: flex;
  align-items: center;
  margin-bottom: 15px;

  .info {
    margin-left: 10px;
  }

  .attendance {
    margin-top: 10px;
  }
}

.record {
  display: flex;
  font-size: 15px;
  font-weight: 600;

  .record-no {
    margin-left: 10px;
    margin-bottom: 15px;
  }

  .record-list {
    margin-left: 10px;

    .record-item {
      margin-bottom: 15px;
    }
  }

  .create-record-btn {
    margin-left: 10px;
    margin-bottom: 15px;
    color: #409eff;
    cursor: pointer;
  }
}

.attendance-details-dialog /deep/ .ui-date-picker {
  position: absolute;
  left: 20px;
  top: 0px;
  visibility: hidden;
}

.updatePunchTimeDialog /deep/ .el-dialog {
  width: 400px;
  min-width: 400px;
}

.updatePunchTimeDialog /deep/ .el-dialog__body {
  text-align: center;
}
</style>
